module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_base.1001.jpg.astc.40a7c9d5.ktx";